<template>
  <v-row>
    <v-col cols="12">
      <v-card flat outlined
        ><v-card-text>
          <iframe
            width="100%"
            height="3000"
            src="https://datastudio.google.com/embed/reporting/32aeb611-cd64-4746-bf3c-cb0689ca0911/page/UWSHC"
            frameborder="0"
            style="border:0"
            allowfullscreen
          ></iframe> </v-card-text
      ></v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Test-page",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {}
};
</script>
